export default __webpack_public_path__ + "static/media/empty-file-icon.4cc14942.svg";